<template>
  <div>
    <v-btn id="btn-novo-ip-acesso" color="accent" dark elevation="0" class="mb-5 mt-5" outlined medium @click="abrirNovo">
      <v-icon left size="30px">mdi-plus-circle</v-icon>
      Novo IP
    </v-btn>

    <v-data-table
      :headers="headers"
      :items="ips"
      :loading="loading"
      :hide-default-header="loading"
      :hide-default-footer="loading"
      :footer-props="{ itemsPerPageText: 'Itens por Página' }"
      no-results-text="Nenhum registro correspondente encontrado"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn id="action-edit-ip-acesso" fab icon x-small @click="abrirEdicao(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn id="action-delete-ip-acesso" fab icon x-small @click="abrirExclusao(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <dialog-delete :dialog.sync="dialogExclusao" @submitTriggered="excluir">
      <template #title>Excluir IP de Acesso</template>
      <template #body>
        Tem certeza que deseja excluir o IP
        <strong>{{ registroSelecionado ? registroSelecionado.ip : '' }}</strong>
        do security group
        <strong>{{ registroSelecionado ? registroSelecionado.security_group_nome : '' }}</strong>
        ?
      </template>
    </dialog-delete>
  </div>
</template>

<script>
  import IpsAcessoBancoDadosAwsService from '@/services/aws/IpsAcessoBancoDadosAwsService';
  import routes from '@/store/modules/routes';

  export default {
    name: 'IpsAcessoBancoDadosTab',

    components: {
      DialogDelete: () => import('@/components/general/DialogDelete.vue')
    },

    data: () => ({
      ips: [],
      loading: false,
      headers: [
        { text: 'IP', value: 'ip' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Security Group', value: 'security_group_nome' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      dialogExclusao: false,
      registroSelecionado: null
    }),

    mounted() {
      this.getIps();
    },

    methods: {
      getIps() {
        this.loading = true;
        IpsAcessoBancoDadosAwsService.listar()
          .then(({ data }) => {
            this.ips = data.data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar os IPs de acesso.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },
      abrirNovo() {
        this.$router.push({ name: routes.state.appRoutes['IPS_ACESSO_BANCO_DADOS_ADICIONAR'] });
      },
      abrirEdicao(item) {
        this.$router.push({
          name: routes.state.appRoutes['IPS_ACESSO_BANCO_DADOS_EDITAR'],
          params: { id: item.id }
        });
      },
      abrirExclusao(item) {
        this.registroSelecionado = item;
        this.dialogExclusao = true;
      },
      excluir() {
        IpsAcessoBancoDadosAwsService.excluir(this.registroSelecionado.id)
          .then(() => {
            this.$toast.success('IP de acesso excluído com sucesso.', '', { position: 'topRight' });
            this.dialogExclusao = false;
            this.getIps();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao excluir o IP de acesso.', '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style scoped></style>
